<template>
  <v-dialog v-model="dialog" max-width="350" :persistent="salvando">
    <template v-slot:activator="{ on, attrs }">
      <v-btn height="45" color="success" block v-on="on" v-bind="attrs" class="font-weight-bold"
        ><v-icon class="mr-2">mdi-truck-check-outline</v-icon> CONFIRMAR CARGA
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold d-flex justify-center"
        >Confirmar formação de carga?</v-card-title
      >
      <v-card-actions class="d-flex justify-center">
        <v-btn
          color="success"
          text
          rounded
          @click="confirmarCarga()"
          :loading="salvando"
          >Sim, confirmar</v-btn
        >
        <v-btn
          color="error"
          @click="dialog = false"
          text
          rounded
          :disabled="salvando"
          >Não, cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    dialog: false,
    salvando: false,
  }),
  methods: {
    ...mapActions("formacaoCarga", ["salvarFormacaoCarga"]),
    async confirmarCarga() {
      this.salvando = true;
      await this.salvarFormacaoCarga();
      this.salvando = false;
    },
  },
};
</script>

<style>
</style>